"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageEditor = void 0;
var React = __importStar(require("react"));
var MarkupImage_1 = require("./MarkupImage");
var CropEditor_1 = require("./CropEditor");
var MarkersEditor_1 = require("./MarkersEditor");
var MediaContext_1 = require("../../MediaContext");
var ImageInfo_1 = require("../../ImageInfo");
var LoadingIndicator_1 = require("./LoadingIndicator");
var react_1 = require("@chakra-ui/react");
var __1 = require("../../..");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var colors_1 = require("../../../DozukiHeader/colors");
function ImageEditor(_a) {
    var onImageEditUploadStart = _a.onImageEditUploadStart, onImageEditUploadComplete = _a.onImageEditUploadComplete, onCancel = _a.onCancel;
    var mediaContext = (0, MediaContext_1.useMediaContext)();
    var _js = mediaContext._js, isUploadingMedia = mediaContext.isUploadingMedia;
    var _b = React.useState(null), srcElement = _b[0], setSrcElement = _b[1];
    var selectedImage = mediaContext.selectedImage;
    var Editor = mediaContext.view === 'markup' ? MarkersEditor_1.MarkersEditor : CropEditor_1.CropEditor;
    var isReady = srcElement && mediaContext.mediaConstraints && selectedImage;
    var isLoading = !srcElement || mediaContext.isLoadingMediaConstraints;
    var failedToLoadMediaConstraints = !mediaContext.isLoadingMediaConstraints && !mediaContext.mediaConstraints;
    var sourceImageInfo = (selectedImage === null || selectedImage === void 0 ? void 0 : selectedImage.srcid) ? selectedImage.srcImageInfo : selectedImage;
    function handleRender(dataUrl, state) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var blob, mediaItemFilterName, mime, extension, filename, file, edits, annotations, mediaItem;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!selectedImage)
                            return [2 /*return*/, null];
                        return [4 /*yield*/, fetch(dataUrl)];
                    case 1: return [4 /*yield*/, (_e.sent()).blob()];
                    case 2:
                        blob = _e.sent();
                        mediaItemFilterName = mediaContext.filter;
                        mime = blob.type;
                        extension = mime.split('/')[1];
                        filename = (_b = (_a = selectedImage.exif) === null || _a === void 0 ? void 0 : _a.FileName) !== null && _b !== void 0 ? _b : "edited-image-".concat(selectedImage.image.id, ".").concat(extension);
                        file = new File([blob], filename);
                        edits = ((_c = selectedImage.markupState) === null || _c === void 0 ? void 0 : _c.edits) || null;
                        annotations = ((_d = selectedImage.markupState) === null || _d === void 0 ? void 0 : _d.annotations) || null;
                        if ((0, ImageInfo_1.isCroproEditsState)(state)) {
                            edits = state;
                            // We blow away any annotations when the image is edited
                            annotations = null;
                        }
                        else if ((0, ImageInfo_1.isMarkerjsMarkersState)(state)) {
                            annotations = state.data.markers.length > 0 ? state : null;
                            // Markup changes shouldn't affect the filter state
                            mediaItemFilterName = null;
                        }
                        if (onImageEditUploadStart) {
                            onImageEditUploadStart();
                        }
                        return [4 /*yield*/, mediaContext.uploadEditedImage(file, selectedImage, {
                                imageid: selectedImage.image.id,
                                edits: edits,
                                annotations: annotations,
                                mediaItemFilterName: mediaItemFilterName,
                            })];
                    case 3:
                        mediaItem = _e.sent();
                        if (onImageEditUploadComplete)
                            onImageEditUploadComplete(mediaItem);
                        return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MarkupImage_1.MarkupImage, { imageInfo: sourceImageInfo, imageSrc: sourceImageInfo === null || sourceImageInfo === void 0 ? void 0 : sourceImageInfo.image.original, onLoad: function (image) { return setSrcElement(image); } }),
        (isLoading || isUploadingMedia || !selectedImage) && (React.createElement(LoadingIndicator_1.LoadingIndicator, { label: isUploadingMedia ? _js('Saving edited image') : _js('Loading image editor'), onClose: onCancel })),
        failedToLoadMediaConstraints && (React.createElement(react_1.Modal, { isOpen: true, onClose: function () { return onCancel === null || onCancel === void 0 ? void 0 : onCancel(); } },
            React.createElement(react_1.ModalOverlay, null),
            React.createElement(react_1.ModalContent, null,
                React.createElement(react_1.ModalCloseButton, { color: colors_1.DEFAULT_TEXT_COLOR, mr: 1 }),
                React.createElement(react_1.ModalBody, { textAlign: "center" },
                    React.createElement(__1.Icon, { type: pro_solid_svg_icons_1.faWarning, fontSize: "2rem", color: "red.400" }),
                    React.createElement(react_1.Heading, { size: "1xl" }, _js('Failed to load image editor, please try again later.')),
                    React.createElement(react_1.Heading, { as: "h3", size: "sm" }, _js('Media constraints are not available.')))))),
        isReady && (React.createElement(Editor, { imageInfo: selectedImage, sourceImage: srcElement, onClose: function () {
                mediaContext.setView('list');
                setSrcElement(null);
            }, onRender: handleRender }))));
}
exports.ImageEditor = ImageEditor;
